module.exports = {
  prismicRepositoryName: 'secure-privacy',

  defaultLanguage: 'en-gb',
  langs: ['en-gb', 'pt-br'],
};
